import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { InputCalendarPage } from 'pages/input-calendar-page/input-calendar-page';

@NgModule({
  declarations: [InputCalendarPage],
  imports: [PagesModule, ComponentsModule],
  exports: [InputCalendarPage]
})
export class InputCalendarPageModule { }
